<template>
  <div>
    <div 
      class="mt-4 grid grid-cols-3 gap-7" 
      name="districtSelection"
      :key="componentKey">
      <ValidationProvider rules="required" name="requesting district" v-slot="{ errors }">
        <VSelectionField
          name="studentDistrict"
          :defaultValue="defaultValue?.studentDistrict?.code + ': ' + defaultValue?.studentDistrict?.name"
          :disabled="!enableDistrictSelection"
          :options="studentDistrictList"
          label="label"
          val="value"
          v-model="formValues.studentDistrict"
          @input="showResidentRequestingDistrict(formValues.studentDistrict)">
          Requesting District
        </VSelectionField>
        <span
          class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          name="error-text">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
      <ValidationProvider v-if="showRequestingDistrict" rules="required" name="member district" v-slot="{ errors }">
        <VSelectionField
          name="requestingDistrict"
          :defaultValue="defaultValue?.requestingDistrict?.code + ': ' + defaultValue?.requestingDistrict?.name"
          :options="requestingDistrictList"
          label="label"
          val="value"
          v-model="formValues.requestingDistrict">
          Member District
        </VSelectionField>
        <span
          class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          name="error-text">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
      <VSelectionField
        v-if="showResidentDistrict"
        name="residentDistrict"
        :defaultValue="defaultValue?.residentDistrict?.code + ': ' + defaultValue?.residentDistrict?.name"
        :options="residentDistrictList"
        label="label"
        val="value"
        v-model="formValues.residentDistrict">
        Resident District
      </VSelectionField>
      <!-- {{ formValues }} -->
    </div>
  </div>
</template>

<script>
import requestFormService from '../services/formSubmission/requestForm.js'

import VSelectionField from './formComponents/VSelectionField.vue'
import cloneDeep from 'clone-deep'

import { isObject, isString, isNil } from 'lodash'


export default {
  components: { VSelectionField },
  props: {
    enableDistrictSelection: Boolean,
    disableDefaultValueUpdates: Boolean,
    districtSelectionType: {
      default: '',
      type: String,
    },
    defaultValue: undefined,
    studentDistrictOptions: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      formValues: {},
      districtList: [],
      studentDistrictList: [],
      requestingDistrictList: [],
      residentDistrictList: [],
      showResidentDistrict: false,
      showRequestingDistrict: false,
      componentKey: 0,
    }
  },
  methods: {
    async updateValue() {
      this.$emit('input', this.formValues)
    },
    async getSelectedDistrict(distValue) {
      var dist = await requestFormService.getDistrictDetail(distValue).then(function(val) {
        return val.data
      })
      return dist
    },
    setDefault() {
      this.componentKey += 1
      if (this.defaultValue === undefined) {
        return
      }

      if (!this.checkSchema(this.defaultValue)) {
        return
      }

      if (this.disableDefaultValueUpdates) {
        return
      }

      this.formValues = cloneDeep(this.defaultValue)
      this.formValues.studentDistrict = this.defaultValue.studentDistrict?.code
      this.formValues.requestingDistrict = this.defaultValue.requestingDistrict?.code
      this.formValues.residentDistrict = this.defaultValue.residentDistrict?.code
      if (this.districtSelectionType === 'all' || this.districtSelectionType === 'single') {
        this.showResidentRequestingDistrict(this.formValues.studentDistrict)
      }

      this.$emit('defaultValueUsed')
    },
    checkSchema(obj) {
      if (!isObject(obj)) {
        console.warn(`Invalid default value data type in DistrictSelection, ${typeof obj}`)
        return false
      }
      if (!(
        isNil(obj.studentDistrict) ||
          (
            isObject(obj.studentDistrict) &&
            (isString(obj.studentDistrict.code) || isNil(obj.studentDistrict.code))
          )
        )) {
        console.warn(`Invalid default value data type in DistrictSelection.studentDistrict.code, ${typeof obj.studentDistrict?.code}`)
        delete obj.studentDistrict
      }
      if (!(
        isNil(obj.requestingDistrict) ||
          (
            isObject(obj.requestingDistrict) &&
            (isString(obj.requestingDistrict.code) || isNil(obj.requestingDistrict.code))
          )
        )) {
        console.warn(`Invalid default value data type in DistrictSelection.requestingDistrict.code, ${typeof obj.requestingDistrict?.code}`)
        delete obj.requestingDistrict
      }
      if (!(
        isNil(obj.residentDistrict) ||
          (
            isObject(obj.residentDistrict) &&
            (isString(obj.residentDistrict.code) || isNil(obj.residentDistrict.code))
          )
        )) {
        console.warn(`Invalid default value data type in DistrictSelection.residentDistrict.code, ${typeof obj.residentDistrict?.code}`)
        delete obj.residentDistrict
      }

      return true
    },
    showResidentRequestingDistrict(districtCode) {
      let district = this.districtList.find(elem => elem.value === districtCode)

      if (district === undefined) return

      if (district.conditions['require_resident_district']) {
        this.showResidentDistrict = true
        if (district.conditions['require_resident_district'].ui_data) {
          this.getResidentDistrictList(district.conditions['require_resident_district'].ui_data)
        }
        else {
          this.residentDistrictList = this.districtList
        }
      }
      else {
        this.showResidentDistrict = false
        this.residentDistrictList = []
        delete this.formValues.residentDistrict
      }

      if (district.conditions['require_requesting_district']) {
        this.showRequestingDistrict = true
        this.getRequestingDistrictList(district.conditions['require_requesting_district'].ui_data)
      }
      else {
        this.showRequestingDistrict = false
        this.requestingDistrictList = []
        delete this.formValues.requestingDistrict
      }
    },
    async getAllDistricts() {
      let result = await requestFormService.getDistrictFromServer()

      this.districtList.length = 0
      for (const district of result.data) {
        let districtObj = {
          value: district.code,
          label: `${district.code}: ${district.name}`,
          conditions: district.ui_data.conditions ? district.ui_data.conditions : [],
        }
        this.districtList.push(districtObj)
      }

      this.studentDistrictList = this.districtList
      this.showResidentRequestingDistrict(this.formValues.studentDistrict)
    },
    async getDistrictByCode(code) {
      let result = await requestFormService.getDistrictDetail(code)

      let district = result.data
      this.districtList.length = 0

      let districtObj = {
        value: district.code,
        label: `${district.code}: ${district.name}`,
        conditions: district.ui_data.conditions ? district.ui_data.conditions : [],
      }

      this.districtList.push(districtObj)

      this.studentDistrictList = this.districtList
      this.showResidentRequestingDistrict(this.formValues.studentDistrict)
    },
    getRequestingDistrictList(districtCodes) {
      // this.requestingDistrictList = []
      // for (var n = 0; n < districtCodes.length; ++n) {
      //   let label = DISTRICT_LIST.find(elem => elem.value === districtCodes[n]).label
      //   console.log(label)
      //   let districtObj = {
      //     value: districtCodes[n],
      //     label: label,
      //   }
      //   this.requestingDistrictList.push(districtObj)
      // }
      var labelMap = this.districtList.reduce((cumulator, curr) => {
        cumulator[curr.value] = curr.label
        return cumulator
      }, {})
      // This code is correct (assuming all the data is present). Keep this for now to
      //   submit the bug report to Babel.
      // this.requestingDistrictList = districtCodes.map(districtCode => {
      //   return {
      //     value: districtCode,
      //     label: labelMap[districtCode],
      //   }
      // })

      let requestingDistrictListPromises = districtCodes.map(districtCode => {
        if (labelMap[districtCode]) {
          return Promise.resolve({
            value: districtCode,
            label: labelMap[districtCode],
          })
        }
        else {
          return requestFormService.getDistrictDetail(districtCode).then(district => {
            this.districtList.push({
              value: district.code,
              label: `${district.code}: ${district.name}`,
              conditions: district.ui_data.conditions ? district.ui_data.conditions : [],
            })
            return {
              value: district.code,
              label: `${district.code}: ${district.name}`,
            }
          })
        }
      })

      Promise.all(requestingDistrictListPromises).then(values => {
        this.requestingDistrictList = values
      })
    },
    getResidentDistrictList(districtCodes) {
      // this.residentDistrictList = []
      // for (var n = 0; n < districtCodes.length; ++n) {
      //   let label = DISTRICT_LIST.find(elem => elem.value === districtCodes[n]).label
      //   console.log(label)
      //   let districtObj = {
      //     value: districtCodes[n],
      //     label: label,
      //   }
      //   this.residentDistrictList.push(districtObj)
      // }
      var labelMap = this.districtList.reduce((cumulator, curr) => {
        cumulator[curr.value] = curr.label
        return cumulator
      }, {})
      // This code is correct (assuming all the data is present). Keep this for now to
      //   submit the bug report to Babel.
      // this.residentDistrictList = districtCodes.map(districtCode => {
      //   return {
      //     value: districtCode,
      //     label: labelMap[districtCode],
      //   }
      // })

      let residentDistrictListPromises = districtCodes.map(districtCode => {
        if (labelMap[districtCode]) {
          return Promise.resolve({
            value: districtCode,
            label: labelMap[districtCode],
          })
        }
        else {
          return requestFormService.getDistrictDetail(districtCode).then(district => {
            this.districtList.push({
              value: district.code,
              label: `${district.code}: ${district.name}`,
              conditions: district.ui_data.conditions ? district.ui_data.conditions : [],
            })
            return {
              value: district.code,
              label: `${district.code}: ${district.name}`,
            }
          })
        }
      })

      Promise.all(residentDistrictListPromises).then(values => {
        this.residentDistrictList = values
      })
    },
  },
  async mounted() {
    if (this.enableGetAllDistricts) {
      await this.getAllDistricts()
    }
    this.setDefault()
  },
  watch: {
    defaultValue() {
      this.setDefault()
    },
    formValues() {
      this.updateValue()
    },
    districtSelectionType(value) {
      if (value === 'all') {
        this.getAllDistricts()
      }
      else if (value === 'single') {
        this.getAllDistricts()
      }
    },
  }
}
</script>
